<template>
    <div class="page">
        <div class="address-list" v-for="item in data.list" :key="item.id">
            <p class="address-name"><span>{{ item.name }}</span>{{ item.phone }}</p>
            <p>{{ item.address }}</p>
            <hr>
            <p class="address-delete">
                <a-popconfirm
                    title="确认要删除吗？"
                    ok-text="删除"
                    cancel-text="取消"
                    @confirm="handleDelete(item.id)"
                >
                    <a>删除</a>
                </a-popconfirm>
            </p>
        </div>
        <div class="add-address">
            <a-button @click="addAddress">新增地址</a-button>
        </div>
    </div>
</template>

<script>
import { getAddressListApi, delAddressApi } from '@/api/address'
import { reactive, onMounted } from 'vue'
import {notification} from "ant-design-vue"
import router from "@/router"
export default {
    name: "AddressList",
    setup() {
        const data = reactive({
            list: []
        })
        const getAddressList = async () => {
            const params = {"current": 1,"model": {}, "size": 200}
            const res = await getAddressListApi(params)
            data.list = res.records
        }
        const handleDelete = async (id) => {
            const res = await delAddressApi(id)
            if (res) {
                notification.success({ message: '删除成功!', description: '', duration: 2 })
                await getAddressList()
            }
        }
        const addAddress = () => {
            router.push({ name: 'AddAddress'})
        }
        onMounted(() => {
            getAddressList()
        })
        return {
            data,
            handleDelete,
            addAddress
        }
    }
}
</script>

<style scoped lang="stylus">
    .page {
        width 100%
        height 100%
        margin-bottom 55px
        padding 15px 20px
        background-color #F7F7F7
        .address-list {
            width 100%
            min-height 1px
            background-color #FFFFFF
            box-shadow 0 4px 15px rgba(0,0,0,0.1)
            border-radius 6px
            padding 10px
            font-size 14px
            margin-bottom 15px
            .address-name {
                font-size 14px
                color #A7A1A1
            }
            .address-name span {
                font-size 16px
                color #000
                font-weight bolder
                margin-right 16px
            }
            .address-delete {
                text-align right
            }
            .address-delete a {
                color #636363
            }
        }
        .add-address {
            width 100%
            text-align center
        }
        .add-address >>> .ant-btn {
            width 240px
            background-color #44A73D
            border-color #44A73D
            color #FFF
            border-radius 23px
        }
    }
</style>